import React, { useCallback, useLayoutEffect, useState } from 'react'
import FilterGroup from './filter_group.jsx'
import { RangeInput } from 'lensrentals-components'
import useDebouncedCallback from '../misc/use_debounced_callback.jsx'
import PropTypes from 'prop-types'

import styles from '../../assets/stylesheets/pages/searches/filters.module.scss'

const SliderFilter = props => {
  const {
    name,
    values,
    filterType,
    selectFilter,
    selectedFilters,
    handleFilterSelection,
    isOpen,
    toggleOpenFilters,
    isExpanded,
    toggleExpandedFilters
  } = props

  const selectFilterDebounced = useDebouncedCallback(
    (selectedFilters, filterType, name, val, event) => handleFilterSelection(selectFilter(selectedFilters, filterType, name, val), event),
    500
  )

  const [index, setIndex] = useState(null)

  const onChangeSliderFilter = useCallback((event) => {
    if (event.target.value) {
      event.persist()
      const selectedIndex = parseFloat(event.target.value)
      setIndex(selectedIndex)
      selectFilterDebounced(selectedFilters, filterType, name, parseFloat(values[selectedIndex]), event)
    }
  }, [filterType, name, selectFilterDebounced, selectedFilters, values])

  useLayoutEffect(() => {
    if (selectedFilters) {
      const currentSelectedFilters = JSON.parse(selectedFilters)
      const existingMinFilter = currentSelectedFilters[filterType].find(filter => filter.name === `${name}`)
      if (existingMinFilter && existingMinFilter.values.length > 0) {
        const currentIndex = values.indexOf(parseFloat(existingMinFilter.values[0]))
        if (currentIndex === -1) {
          setIndex(null)
        } else {
          setIndex(currentIndex)
        }
      } else {
        setIndex(null)
      }
    }
  }, [selectedFilters, filterType, name, values])

  const filterName = name
  return (
    <FilterGroup
      name={name}
      isOpen={isOpen}
      toggleOpenFilters={toggleOpenFilters}
      isExpanded={isExpanded}
      toggleExpandedFilters={toggleExpandedFilters}
    >
      <RangeInput
        className={styles['filter--slider']}
        name={name}
        key={`${filterName}-${name}`}
        id={`${filterName}-${name}`}
        min={0}
        max={values.length - 1}
        value={index}
        onClick={values.length === 1 ? onChangeSliderFilter : null}
        onChange={onChangeSliderFilter}
      />
      {index !== null &&
        <span>
          {values[index]}
        </span>}
    </FilterGroup>
  )
}
SliderFilter.propTypes = {
  name: PropTypes.string.isRequired,
  values: PropTypes.array.isRequired,
  filterType: PropTypes.string.isRequired,
  selectFilter: PropTypes.func.isRequired,
  selectedFilters: PropTypes.string.isRequired,
  handleFilterSelection: PropTypes.func.isRequired
}
export default SliderFilter
